import { Component } from '@angular/core';
import { CustomerDetailsInfoTabComponent } from 'gung-standard';

@Component({
  selector: 'gung-jeeves-jeeves-customer-details-info-tab',
  templateUrl: './jeeves-customer-details-info-tab.component.html',
  styleUrl: './jeeves-customer-details-info-tab.component.css',
  standalone: false
})
export class JeevesCustomerDetailsInfoTabComponent extends CustomerDetailsInfoTabComponent {

}
